"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = void 0;
const isObject_1 = require("./isObject");
const isError = (value) => {
    if (!(0, isObject_1.isObject)(value)) {
        return false;
    }
    return typeof value.message === 'string';
};
exports.isError = isError;
